module.exports = __webpack_public_path__ + "img/gal_6.b0aff933.png";